export default __webpack_public_path__ + "static/media/icon_close.46e011c3.svg";